import { r as e } from "../../chunks/index.es.wVhS2yfK.js";
import { Element as t, Node as n, Transforms as r } from "slate";
// lib/Link/lib/normalizeNode.ts
var i = (i, a) => {
	let [o, s] = a;
	if (t.isElement(o) && e.isOfType(o, "core/link") && n.string(o).trim() === "") return r.unwrapNodes(i, {
		at: s,
		match: (n) => t.isElement(n) && e.isOfType(n, "core/link")
	}), !0;
};
export { i as normalizeNode };
